import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import {
  PanelToggle,
  SpacingVertical,
  RadioButtonsGroup,
  Flex,
  Badge,
  TooltipUtils
} from 'mailup-web-components'
import {
  STORE_KEY_FEATURES,
  storeGet,
  useConditions
} from 'mailup-react-helpers'
import { useRecoilState, useRecoilValue } from 'recoil'
import { modalSchedulingState } from 'Pages/EmailSendingWizard/recoil/state/modals'
import { ModalContentScheduled } from '../BoxSendingManage/ModalSchedule/components/ModalContentScheduled'
import {
  ContentImmediate,
  WarningMessage
} from '../BoxSendingManage/ModalSchedule/components'
import { isScheduledSendingState } from 'Pages/EmailSendingWizard/recoil/state/senderInfo'
import {
  MODE_IMMEDIATE,
  MODE_SCHEDULED,
  MODE_SMART,
  STORE_KEY_ACCOUNT
} from 'Constants/index'
import { progressState } from 'Pages/EmailSendingWizard/recoil/state/queue'
import {
  BEQUEUE_CONFIG_STATE_FAILED,
  BEQUEUE_CONFIG_STATE_RUNNING
} from 'Api/beQueueApi'
import styled from '@emotion/styled'
import aiLightningAzure from 'Img/ai-lightning-azure.svg'
import aiLightningWhite from 'Img/ai-lightning-white.svg'
import { smartPlanningState } from 'Pages/EmailSendingWizard/recoil/state/page'

const StyledBadgeAI = styled(Badge)`
  padding: 8px 6px;
  border: 0;
  color: ${props =>
    props.disabled ? 'white' : props.active ? '#16a7cd' : 'white'};
  background-color: ${props =>
    props.disabled ? '#AAAAAA' : props.active ? 'white' : '#16a7cd'};
  height: 19px;
`

const BoxSheduleSending = () => {
  const intl = useIntl()

  const [
    { isScheduledSending, scheduleModeSelected, scheduleMode },
    setIsScheduledSending
  ] = useRecoilState(isScheduledSendingState)
  const { startDate } = useRecoilValue(modalSchedulingState)

  const handleOnChangeToggle = () => {
    setIsScheduledSending(prev => ({
      ...prev,
      isScheduledSending: !isScheduledSending
    }))
  }
  const { queueStatus } = useRecoilValue(progressState)
  const { smartPlanningError } = useRecoilValue(smartPlanningState)

  const [disableSchedule, disableImmediateSending] = useConditions([
    'uo:NOSCHED',
    'uo:NOIMMEDIATESEND'
  ])

  const smartPlanningFeature =
    storeGet(STORE_KEY_FEATURES).indexOf('smartPlanning') >= 0
  const account = storeGet(STORE_KEY_ACCOUNT)
  const showSmartPlanning =
    smartPlanningFeature &&
    account.IdOffer !== 3 &&
    account.IdOffer !== 2 &&
    account.IdOffer !== 6 &&
    !account.IsOfferLight // NON E' UNA STARTER - FREQUENZA - SOLOSMS-LIGHT

  useEffect(() => {
    let ret = []
    if (!startDate) {
      ret = [
        ...(showSmartPlanning ? [MODE_SMART] : []),
        ...(!disableSchedule ? [MODE_SCHEDULED] : []),
        ...(!disableImmediateSending ? [MODE_IMMEDIATE] : [])
      ]

      setIsScheduledSending(prev => ({
        ...prev,
        scheduleModeSelected:
          showSmartPlanning && smartPlanningError ? ret[1] : ret[0],
        scheduleMode: ret
      }))
    } else {
      ret = [
        ...(showSmartPlanning ? [MODE_SMART] : []),
        MODE_SCHEDULED,
        MODE_IMMEDIATE
      ]

      setIsScheduledSending(prev => ({
        ...prev,
        scheduleModeSelected:
          showSmartPlanning && smartPlanningError ? ret[1] : ret[0],
        scheduleMode: ret
      }))
    }
  }, [smartPlanningError])

  useEffect(() => {
    setTimeout(() => {
      TooltipUtils.rebuild()
    })
  }, [showSmartPlanning, smartPlanningError])

  return (
    <>
      <PanelToggle
        onChange={handleOnChangeToggle}
        checked={isScheduledSending}
        title={intl.formatMessage({
          id: 'Load.Schedulation.SendTypePlannngTitle'
        })}
        data-mu-test='PanelToggle_FasciaDiNonDisturbo'
        disabled={
          queueStatus === BEQUEUE_CONFIG_STATE_RUNNING ||
          queueStatus === BEQUEUE_CONFIG_STATE_FAILED
        }
      >
        <>
          <WarningMessage />
          {scheduleMode.length > 1 && (
            <>
              <RadioButtonsGroup
                value={scheduleModeSelected}
                onChange={value =>
                  setIsScheduledSending(prev => ({
                    ...prev,
                    scheduleModeSelected: value
                  }))
                }
                items={[
                  ...(showSmartPlanning
                    ? [
                        {
                          disabled: smartPlanningError,
                          'data-mu-test': 'sendType-AiPlanning',
                          label: (
                            <Flex
                              alignItems='center'
                              gap='4px'
                              data-tip={
                                smartPlanningError === 'NoData'
                                  ? intl.formatMessage({
                                      id:
                                        'Load.Schedulation.TooltipNoDataForSmartDate'
                                    })
                                  : smartPlanningError === 'DataError'
                                  ? intl.formatMessage({
                                      id:
                                        'Load.Schedulation.TooltipAiPlanningDataError'
                                    })
                                  : undefined
                              }
                            >
                              {intl.formatMessage({
                                id: 'Load.QueueStatus.AiPlanningTitle'
                              })}

                              <StyledBadgeAI
                                type='info'
                                kind='default'
                                active={scheduleModeSelected === MODE_SMART}
                                disabled={smartPlanningError}
                                text={
                                  <Flex alignItems='baseline' gap='2px'>
                                    BETA AI
                                    <img
                                      src={
                                        scheduleModeSelected === MODE_SMART
                                          ? aiLightningAzure
                                          : aiLightningWhite
                                      }
                                    />
                                  </Flex>
                                }
                              />
                            </Flex>
                          ),
                          value: MODE_SMART
                        }
                      ]
                    : []),
                  {
                    label: intl.formatMessage({
                      id: 'Load.Schedulation.SendTypeScheduledChoice'
                    }),
                    value: MODE_SCHEDULED,
                    'data-mu-test': 'sendType-scheduled'
                  },
                  {
                    label: intl.formatMessage({
                      id: 'Load.Schedulation.SendTypeSequenzialeChoice'
                    }),
                    value: MODE_IMMEDIATE,
                    'data-mu-test': 'sendType-sequenziale'
                  }
                ]}
              />
              <SpacingVertical />
            </>
          )}

          {(() => {
            switch (scheduleModeSelected) {
              case MODE_SCHEDULED:
              case MODE_SMART:
                return <ModalContentScheduled mode={scheduleModeSelected} />

              case MODE_IMMEDIATE:
                return <ContentImmediate />
            }
          })()}
        </>
      </PanelToggle>
    </>
  )
}

export default BoxSheduleSending
